var _defs, _g, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56.21 53.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #0d6db5;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m28.27,45.74c-.05-.02-.11-.03-.17-.03s-.11.01-.17.03l-16.71,7.04,1.53-18.06c.01-.12-.03-.23-.1-.32L.8,20.68l17.65-4.13c.11-.03.21-.1.27-.2L28.1.84l9.38,15.51c.06.1.16.17.27.2l17.65,4.13-11.86,13.72c-.08.09-.11.2-.1.32l1.53,18.06-16.71-7.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m28.1,1.68l9.01,14.9c.12.2.32.34.55.4l16.95,3.96-11.39,13.17c-.15.18-.23.41-.21.64l1.47,17.35-16.05-6.76c-.11-.05-.22-.07-.34-.07s-.23.02-.34.07l-16.05,6.76,1.47-17.35c.02-.23-.06-.46-.21-.64L1.6,20.94l16.95-3.96c.23-.05.42-.2.55-.4L28.1,1.68m0-1.68l-9.75,16.13L0,20.42l12.33,14.26-1.59,18.78,17.37-7.32,17.37,7.32-1.59-18.78,12.33-14.26-18.35-4.29L28.1,0h0Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m29.36,28.97c-1.42,5.43-1.42,11.18-.17,16.64.18.67-.49.12-1.15.3-.91.27-1.53.6-1.26-.3,1.24-5.47,1.24-11.21-.18-16.64-.54-2.46,3.3-2.47,2.76,0h0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m28.8,27.14c4.54,3.22,9.86,5.25,15.35,6.07.69.07-.34.54-.41,1.23-.07.94.29,1.59-.45,1.03-2.29-1.63-4.81-2.74-7.4-3.75-2.62-.96-5.26-1.75-8.07-1.99-.79-.06-1.39-.75-1.33-1.54.05-1.12,1.46-1.74,2.32-1.03h0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m27.3,27.25c4.08-2.64,7.1-6.68,9.1-11.09.39-.96.68-.45,1.27.05.36.31,1.31.29,1.09.88-.1.26-.28.47-.51.61-2.07,1.34-3.53,3.26-5.08,5.12-1.53,1.9-2.88,3.87-3.75,6.2-.27.77-1.11,1.17-1.88.89-1.17-.37-1.31-2.09-.25-2.66h0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m26.69,29.25c-1.77-4.65-5.09-8.94-8.97-12.02-.57-.41.51-.56.92-1.13.55-.82.85-1.13,1.16-.21.44,1.2,1.09,2.38,1.72,3.44,1.98,3.14,4.29,6.08,7.37,8.24,2.04,1.65-1.15,4.08-2.2,1.67h0Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m12.32,33.28c5.38-.81,10.51-2.99,14.92-6.16.54-.43,1.33-.33,1.75.21.6.73.12,1.9-.81,2.01-1.38.19-2.69.55-3.98.96-3.86,1.3-7.6,2.95-10.8,5.52-.97.69-.57-.55-.94-1.24-.4-.77-1.45-1.06-.14-1.31h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueStar);
export default __webpack_public_path__ + "static/media/BlueStar.d8ecacfd0ba9d427009546775663e1e1.svg";
export { ForwardRef as ReactComponent };